import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { ModalIndices } from '../../common/i-doc/i-doc.registry.ts';

interface CalculationExplanationModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  explanation: string | null;
}

export const CalculationExplanationModal: React.FC<CalculationExplanationModalProps> = ({ open, onClose, title, explanation }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth data-i-doc={ModalIndices.CALCULATION_EXPLANATION}>
      <DialogTitle>Пояснення розрахунку: {title}</DialogTitle>
      <DialogContent dividers>
        {explanation ? (
          <Box sx={{ whiteSpace: 'pre-wrap' }}>
            {explanation.split('\n').map((line, index) => (
              <Typography key={index} sx={{ mt: 0.5 }}>{line}</Typography>
            ))}
          </Box>
        ) : (
          <Typography>Наразі пояснення для цієї метрики відсутнє.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Закрити</Button>
      </DialogActions>
    </Dialog>
  );
};
